import { AvatarGroup, Box, Chip, useTranslation, useTranslationRoute, useUrlParamsValueToString } from "@bsm/component";
import { TUserStudentFamily } from "@bsm/graphql";
import { useMemo } from "react";
import { Link } from "react-router-dom";

export const UserStudentFamilyListItem = (props: Partial<TUserStudentFamily>) => {

    const t = useTranslation()
    const tr = useTranslationRoute()
    const urlParams = useUrlParamsValueToString()

    const userList = useMemo(() => {
        return props.members.filter(member => !member.student.isEnrolled).map((item) => {
            return {
                title: (
                    <Box className="flex items-center gap-2">
                        <h5 className="font-bold">{item.student?.user.fullName}</h5>
                        <p>{t(`Bsm.Invoice.User.Student.Family.Members.${item.type}.Label`)}</p>
                    </Box>
                ),
                pictureId: item.student?.user.id,
                itemLink: tr(`admin/students/${item?.student.id}`),
            };
        })
    }, [props.members])

    return (
        <div className="relative flex flex-col border-b border-default pb-4 w-full">
            <div className="flex gap-2">
                <Link to={`${props.id}?${urlParams}`}>
                    <h5 className="tracking-wider font-bold">
                        {props.designation}
                    </h5>
                </Link>
            </div>
            <div className="flex flex-wrap gap-4">
                <AvatarGroup size="xs" avatarItems={userList} itemLimit={5} />
                <div className="flex gap-2 flex-wrap">
                    {props.currencies?.map((item, index) => {
                        return (
                            <Chip key={index} label={t(item.translationKey as any)} />
                        )
                    })
                    }
                </div>
            </div>
        </div>
    )
}

